import type { ReactNode } from 'react';

export function PageHead({
  title,
  description,
  crumbs,
  actions,
}: {
  title: ReactNode;
  description?: ReactNode;
  crumbs?: ReactNode;
  actions?: ReactNode;
}): JSX.Element {
  return (
    <header className="page-head">
      <div className="grow">
        {crumbs ? <div className="crumbs">{crumbs}</div> : null}
        <h1>{title}</h1>
        {description ? <p className="muted page-desc">{description}</p> : null}
      </div>
      {actions ? <div className="row">{actions}</div> : null}
    </header>
  );
}
